// extracted by mini-css-extract-plugin
module.exports = {"subHeading":"StepAvatar_subHeading__k9DEk","avatarWrapper":"StepAvatar_avatarWrapper__2n69U"};